import React, { useEffect, useState } from 'react'
import { axiosPost } from '../../utils/AxiosApi';
import { URL } from '../../utils/Constants';
import moment from 'moment';

const FeedbackResponse = (props) => {
     const [reply, setReply] = useState("");
     const [feedbacksData, setFeedbacksData] = useState([]);
    const feedback = props.feedback;
    useEffect(() => {
        fetchResponses();
    }, [])
    const fetchResponses = () => {
        const param = {
            feedbackId: feedback.id
        }
        axiosPost(
            URL.getFeedbackResponses,
            param,
            (response) => {
                if (response.status === 200) {
                    setFeedbacksData(response.data.data);
                }
            }
        );
    }

    const submitResponse = () => {
        const param = {
            feedbackId: feedback.id,
            response: reply
        }
        axiosPost(
            URL.submitFeedbackResponse,
            param,
            (response) => {
                if (response.status === 200) {
                    fetchResponses();
                    setReply("");
                }
            }
        );
    }
  return (
    <div className="card" style={{ height: "60vh" }}>
      {/* Header */}
          <div className="card-header bg-white row d-flex align-items-start p-1">
              <div className="col">
                  <span className="small font-weight-bold">{feedback?.schoolName}</span><br/>
                  <span className="badge badge-info mr-2">
                           {feedback?.feedbackTypeName}
                        </span>
              </div>
               <div className="col">
              <button type="button" className="close" data-dismiss="alert" data-target="#closeablecard" aria-label="Close" onClick={props.handleCancel}>
                  <span aria-hidden="true">&times;</span>
              </button>
               </div>
          </div>

      {/* Messages */}
      <div
        className="card-body overflow-auto"
      >
        {
            <div
            key={feedback.id}
            className={"d-flex mb-3 justify-content-start"}
          >
            <div
              className={"p-2 rounded  bg-white border"}
              style={{ maxWidth: "70%" }}
            >
              <div className="small font-weight-bold">
                {feedback.name}
              </div>
              <div>{feedback.description}</div>
              <div className="small text-muted text-right">
                {moment(feedback.createdAt).fromNow()}
              </div>
            </div>
          </div>
        }
        {feedbacksData && feedbacksData.map((msg) => (
          <div
            key={msg.id}
            className={"d-flex mb-3 justify-content-end"}
          >
            <div
              className={"p-2 rounded bg-primary text-white" }
              style={{ maxWidth: "70%" }}
            >
              <div>{msg.response}</div>
              <div className="small text-white text-right">
                {moment(msg.createdAt).fromNow()}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Reply Box */}
      <div className="card-footer bg-white p-1">
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Write a response..."
            value={reply}
            onChange={(e) => setReply(e.target.value)}
          />
          <div className="input-group-append">
            <button
              className="btn btn-primary"
              onClick={submitResponse}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeedbackResponse